import Address from "@mapmycustomers/shared/types/Address";
import { GeoManagementState } from "@mapmycustomers/shared/types/base/Located";
import GeoAddress from "@mapmycustomers/shared/types/GeoAddress";
import { GeoPoint } from "@mapmycustomers/shared/types/shapes";

export const getAddress = (
  formValues: any,
  geoManagementState?: GeoManagementState
): Address & {
  geoAddress: GeoAddress;
  geoManagementState: GeoManagementState;
  geoPoint: GeoPoint;
} => {
  const lat = parseFloat(formValues.latitude);
  const lon = parseFloat(formValues.longitude);
  const address = formValues.addressDetails
    ? {
        ...formValues.addressDetails,
        geoManagementState: formValues.addressDetails.geoManagementState
          ? formValues.addressDetails.geoManagementState
          : (geoManagementState ?? GeoManagementState.AUTOMATIC_PRESERVE_ADDRESS),
        geoPoint:
          isNaN(lat) || isNaN(lon)
            ? null
            : { coordinates: [lon, lat] as [number, number], type: "Point" },
        region: formValues.addressDetails.region,
        regionCode: formValues.addressDetails.regionCode,
      }
    : {};
  return address;
};
